import { getFirestore } from "firebase-admin/firestore";
const HEALTH_DOC_ID = "email-service";
async function getHealthStatus() {
  const db = getFirestore();
  const doc = await db.collection("system-health").doc(HEALTH_DOC_ID).get();
  if (!doc.exists) {
    return {
      emailService: "healthy",
      consecutiveFailures: 0,
      timestamp: Date.now()
    };
  }
  const data = doc.data();
  return {
    emailService: data.status,
    consecutiveFailures: data.consecutiveFailures || 0,
    lastSuccessfulSend: data.lastSuccessfulSend,
    timestamp: Date.now()
  };
}
async function updateHealthStatus(result) {
  const db = getFirestore();
  const docRef = db.collection("system-health").doc(HEALTH_DOC_ID);
  const doc = await docRef.get();
  if (result.success) {
    await docRef.set(
      {
        status: "healthy",
        consecutiveFailures: 0,
        lastSuccessfulSend: Date.now(),
        lastHealthCheck: Date.now()
      },
      { merge: true }
    );
  } else {
    const currentFailures = doc.exists ? doc.data().consecutiveFailures || 0 : 0;
    const newFailures = currentFailures + 1;
    let status = "healthy";
    if (newFailures >= 5) {
      status = "unavailable";
    } else if (newFailures >= 3) {
      status = "degraded";
    }
    await docRef.set(
      {
        status,
        consecutiveFailures: newFailures,
        lastHealthCheck: Date.now(),
        errorLog: [...(doc.data()?.errorLog || []).slice(-9), { timestamp: Date.now(), errorType: result.errorType }]
      },
      { merge: true }
    );
  }
}
export {
  getHealthStatus as g,
  updateHealthStatus as u
};
